import { render } from "./static-table.vue?vue&type=template&id=9ac59ce0"
import script from "./static-table.vue?vue&type=script&lang=js"
export * from "./static-table.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__